module.exports = __webpack_public_path__ + "img/wel_title-4.2af61e82.png";